/**
 * Cliente API de proyectos (Sprint 13 S13-25).
 *
 * CRUD completo para mantenedor en sa. Proyectos son iniciativas con
 * presupuesto y multiples gastos asociados ("Riego automatico plaza",
 * "Pintura sede social", etc.). Estados: propuesto, aprobado,
 * en_ejecucion, cerrado, cancelado.
 *
 * DELETE es soft: cambia el estado a 'cancelado' (convencion #5).
 */
import { apiFetch } from './client';

export type EstadoProyecto =
  | 'propuesto'
  | 'aprobado'
  | 'en_ejecucion'
  | 'cerrado'
  | 'cancelado';

export interface ProyectoRead {
  id: string;
  nombre: string;
  descripcion: string | null;
  presupuesto: number;
  inicio: string;
  fin_estimado: string | null;
  fin_real: string | null;
  estado: EstadoProyecto;
  aprobado_acta_url: string | null;
  creado_at: string;
  actualizado_at: string;
}

export interface ProyectoCreate {
  nombre: string;
  descripcion?: string | null;
  presupuesto: number;
  inicio: string;
  fin_estimado?: string | null;
  fin_real?: string | null;
  estado?: EstadoProyecto;
  aprobado_acta_url?: string | null;
}

export interface ProyectoUpdate {
  nombre?: string;
  descripcion?: string | null;
  presupuesto?: number;
  inicio?: string;
  fin_estimado?: string | null;
  fin_real?: string | null;
  estado?: EstadoProyecto;
  aprobado_acta_url?: string | null;
}

export function listProyectos(
  filtros: { estado?: EstadoProyecto } = {},
): Promise<ProyectoRead[]> {
  const params = new URLSearchParams();
  if (filtros.estado) params.set('estado', filtros.estado);
  const qs = params.toString();
  return apiFetch<ProyectoRead[]>(`/proyectos/${qs ? `?${qs}` : ''}`);
}

export function crearProyecto(data: ProyectoCreate): Promise<ProyectoRead> {
  return apiFetch<ProyectoRead>('/proyectos/', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export function actualizarProyecto(
  id: string,
  data: ProyectoUpdate,
): Promise<ProyectoRead> {
  return apiFetch<ProyectoRead>(`/proyectos/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
  });
}

// Soft delete: el backend cambia estado a 'cancelado' y retorna el proyecto.
export function cancelarProyecto(id: string): Promise<ProyectoRead> {
  return apiFetch<ProyectoRead>(`/proyectos/${id}`, { method: 'DELETE' });
}
